import { useLocation } from "react-router-dom"

export const useHideOldComponents = () => {
    const routesToHide = ['/login', '/register', '/forgot-password', '/verify', '/reset-password'];
    const location = useLocation();
    return routesToHide.includes(location.pathname);
}